import { useIntl } from 'react-intl';

const Translator = (data: string): string => {
  return useIntl().formatMessage({ id: data });
};

export default Translator;
